import Vue from "vue";
import VueCompositionApi from "@vue/composition-api";
import Vuex from "vuex";
import {root} from "@/shared/store";
import {PortalTopicWidgetState} from "@/apps/PortalTopicWidget/models/portal-topic-widget-state";
import PortalTopicWidget from "@/apps/PortalTopicWidget/components/PortalTopicWidget.vue";

Vue.use(VueCompositionApi);

Vue.config.productionTip = false;

let portalWidgetEle = document.querySelectorAll('widget-portal-topic');
if (portalWidgetEle.length) {
    portalWidgetEle.forEach(el => {
        let store = new Vuex.Store({
            state: new PortalTopicWidgetState(),
            modules: {
                root
            }
        })

        new Vue({
            el: el,
            store,
            render(h: any) {
                let title = this.$el.attributes.getNamedItem('title');
                let introText = this.$el.attributes.getNamedItem('intro-text');
                let subtopics = this.$el.attributes.getNamedItem('subtopics');

                return h(PortalTopicWidget, {
                    props: {
                        title: title ? title.value : null,
                        introText: introText ? introText.value : null,
                        subtopics: subtopics ? JSON.parse(subtopics.value) : null,
                    }
                })
            }
        });
    });
}
